<script setup lang="ts">
  import { computed, ref, watch } from 'vue';
  import type { MpfDetailsEmits, MpfDetailsProps } from './MpfDetails.props';
  import { mpfDetailsDefaults } from './MpfDetails.props';

  const props = withDefaults(defineProps<MpfDetailsProps>(), mpfDetailsDefaults);
  const emit = defineEmits<MpfDetailsEmits>();

  defineOptions({
    name: 'MpfDetails',
  });

  const detailsId = computed(() => props.id || 'mpf-details');

  // `open` seeds the state; the native element owns it in between.
  const isOpen = ref(props.open);
  watch(
    () => props.open,
    (value) => {
      isOpen.value = value;
    },
  );

  const onToggle = (event: Event) => {
    isOpen.value = (event.target as HTMLDetailsElement).open;
    emit('toggle', isOpen.value);
  };
</script>

<template>
  <details class="mpf-details" :id="detailsId" :open="isOpen" @toggle="onToggle">
    <summary class="mpf-details__summary">
      <component :is="headingLevel ? `h${headingLevel}` : 'span'" class="mpf-details__summary-text">
        {{ summary }}
      </component>
    </summary>
    <div class="mpf-details__text">
      <slot />
    </div>
  </details>
</template>

<style lang="scss" scoped>
  @use './MpfDetails.scss';
</style>
